import React from 'react';
import { CardModuleUI } from '../../common';
import { Grid, IconButton, withStyles } from '@material-ui/core';
import IconCross from './IconCross';
import { MessageTextTips } from './MessageTextTips';

const CardStoreTips_ = ({
  classes,
  idCountry,
  cantidadVentas,
  handleCloseCardTips,
}) => {
  const titleCard =
    cantidadVentas === 1
      ? '¡Felicitaciones! Realizaste tu primera venta'
      : 'Potenciá tu tienda virtual';

  return (
    <CardModuleUI>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.containerTitleTips}>
            <h3 className={classes.title}>{titleCard}</h3>
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.icon_button}
              onClick={handleCloseCardTips}
            >
              <IconCross />
            </IconButton>
          </div>
        </Grid>
        <Grid item xs={12}>
          <MessageTextTips
            idCountry={idCountry}
            cantidadVentas={cantidadVentas}
          />
        </Grid>
      </Grid>
    </CardModuleUI>
  );
};

const styles = () => ({
  containerTitleTips: {
    display: 'flex',
    marginTop: '12px',
    justifyContent: 'space-between',
  },
  title: {
    margin: '0px',
    color: '#53B755',
    fontWeight: '600',
    fontSize: '1.5rem',
    lineHeight: '28px',
  },
  icon_button: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export const CardStoreTips = withStyles(styles)(CardStoreTips_);
